import { toaster } from 'uikit/Toaster'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { api } from 'api'

const useDeclineIdentification = (id: string) => {
  const queryClient = useQueryClient()
  
  return useMutation({
    mutationFn: (data) => api.identifications.declineIdentification(id, data),
    onError: (error) => {
      toaster.create({
        title: 'Не удалось изменить статус пользователя',
        description: error?.message,
        type: 'error',
      })
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['userCard'] })
      toaster.create({
        title: 'Готово',
        description: 'Пользвательл успешно отклонен',
        type: 'success',
      })
    }
  })
}

export default useDeclineIdentification
